<fw-dialog [showClose]="false" class="operation-feedback" width="small">
  <fw-dialog-header>
    <div class="operation-feedback-header"> <span *ngIf="itemsInProgressCount;else completed">{{
        itemsInProgressCount === 1 ?
          ('operationFeedback.downloadInProgress' | translate | interpolate: itemsInProgressCount) : 'operationFeedback.downloadsInProgress' | translate | interpolate: itemsInProgressCount
      }} </span>
      <ng-template #completed>
        {{
          finishedItemsCount === 1 ?
            ('operationFeedback.downloadFinished' | translate | interpolate: finishedItemsCount) : 'operationFeedback.downloadsFinished' | translate | interpolate: finishedItemsCount
        }}
      </ng-template>
      <div class="operation-feedback-header-actions">
        <fw-icon-button (click)="isOpen = !isOpen" [icon]="isOpen ? 'chevron-down' : 'chevron-up'" color="slate"
          size="small"></fw-icon-button>
        <div>
          <fw-icon-button (click)="onCloseClick()" color="slate" icon="close" size="small"></fw-icon-button>
          <div #popoverTrigger class="operation-feedback-header-actions-popover-trigger ">
          </div>
        </div>
        <fw-popover [trigger]="popoverTrigger" action="click" position="above-left">
          <operation-cancel-popover-body (onCancelClick)="closePopover()"
            (onSubmitClick)="close.emit(); closePopover() "
            [cancelTitle]="'operationFeedback.popover.cancelTitle' | translate"
            [submitTitle]="'operationFeedback.popover.submitTitle' | translate"
            [text]="'operationFeedback.popover.text' | translate"
            [title]="'operationFeedback.popover.title' | translate"></operation-cancel-popover-body>
        </fw-popover>
      </div>
    </div>
  </fw-dialog-header>

  <fw-dialog-content>
    <ng-container *ngIf="isOpen">
      <div @toggle>
        <div [class.scrollable]="isOpen" class="operation-feedback-body">
          <operation-feedback-item (cancel)="cancel.emit($event)" (refresh)="refresh.emit($event)"
            *ngFor="let item of items; trackBy: trackByOperationFeedbackItem" [data]="item">
          </operation-feedback-item>
        </div>
      </div>
    </ng-container>
  </fw-dialog-content>
</fw-dialog>
